module.exports = __webpack_public_path__ + "static/img/img_1_wechat.aac4e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_1_wechat.png
// module id = nz+V
// module chunks = 0